var lang = $("html").attr('lang');
if(lang == 'en')
{
 lang = ''; 
}
else
{
  lang = "/"+lang;
}

$(document).ready(function(){
  console.log("script working");
  $('[data-fancybox="images"]').fancybox({
  buttons: [
    "slideShow",
    "thumbs",
    "zoom",
    "fullScreen",
    "share",
    "close"
  ],
  loop: false,
  protect: true
});
})
$(document).ready(function(){
  console.log('run')
  $('.cv_match_main.coll_match_also_like').slick({
  slidesToShow: 4,
     infinte:true,
     autoplay:true,
  dots:false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }
  ]  
  });

  
   jQuery('.might_also_like').slick({
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });




  
  $('.carousel1').slick({
  slidesToShow: 4,
  dots:false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]  
  });

    $('.carousel-products').slick({
    slidesToShow: 4,
    dots:false,
    autoplay: true,
    autoplaySpeed: 3000,  
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1
      }
    }
  ]  
  });
  
});

    $(document).ready(function(){
      $('div#shopify-section-template--17550679703862__featured-collection  .grid__item.grid-product').each(function(){
        var fabrice_price = $(this).find('.withfeb').attr('data-fprice');
        console.log('fabrice_price '+fabrice_price);
        var fab_comp =$(this).find('.cv_price_comp').attr('data-c');
        var fab_sale = $(this).find('.cv_fabric_sale').attr('data-sale');
        fab_sale = fab_sale * 10;
        fab_sale = fab_sale /100;
        fab_sale = parseInt(fab_sale);
        fab_sale = fab_sale.toFixed(2);
        fab_sale = '$'+fab_sale+ '/Meter';
        $(this).find('.cv_fabric_sale').text(fab_sale);
//        console.log('fab_sale '+fab_sale);
        fab_comp = fab_comp *10;
        fab_comp = fab_comp /100;
        fab_comp = parseInt(fab_comp);
        fab_comp = fab_comp.toFixed(2);
        fab_comp = '$'+fab_comp+ '/Meter';
        $(this).find('.cv_price_comp').text(fab_comp);
//         console.log('fab_comp '+fab_comp);
        fabrice_price = fabrice_price *10;
        fabrice_price = fabrice_price /100;
        fabrice_price = parseInt(fabrice_price);
        fabrice_price = fabrice_price.toFixed(2);
        fabrice_price = '$'+fabrice_price+ '/Meter';
        $(this).find('.withfeb').text(fabrice_price);
      });
      
 
    });


  //    facric template js for meter and centimeter code start here 
jQuery(document).ready(function(){

  window.meterCentimeter = function(){
    console.log("worked")
    var minusmin_qty, plusmin_qty,min_qty, sec_optionval,contain_val,combo_price_sel,combo_value, fabric_comp, fabric_stock, plus_mul_price,plus_quan_update,plus_qttt_val,plus_var_price,plus_qunt_val,plus_meter_val,page_load_price,page_load_price_cus,qunt_val, meter_val, cent_val,qttt_val,qaunt_vall,v_price,quan_update,cent_val_update,quntupdate_val,combo_quant,var_price,combo_price,mul_price,var_price_fc,mul_price_woc,mul_pricess,mul_prices;
    fabric_comp = $('.cv_fabric_comp').attr('data-comp');
    fabric_comp = fabric_comp * 10;
    fabric_comp = fabric_comp/100;
    fabric_comp = fabric_comp.toFixed(2);
    fabric_comp = '$'+fabric_comp+ '/Meter';
    $('.cv_fabric_comp').text(fabric_comp);
    fabric_stock = $('.cv_fabric_stock').text();
    fabric_stock =parseInt(fabric_stock);
    fabric_stock = fabric_stock / 10;
    $('.cv_fabric_stock').text(fabric_stock)
    page_load_price = $('.product-price-fabric').attr('data-p');
    page_load_price = parseInt(page_load_price);
    page_load_price = page_load_price * 10;
    page_load_price = page_load_price/100;
    page_load_price = page_load_price.toFixed(2);
    page_load_price = '$'+page_load_price+ '/Meter';
    jQuery('.product-price-fabric').text(page_load_price);
    page_load_price_cus = $('.product-price-fabric_custom').attr('data-price');
    page_load_price_cus = parseInt(page_load_price_cus);
    page_load_price_cus = page_load_price_cus * 10;
    page_load_price_cus = page_load_price_cus/100;
    page_load_price_cus = page_load_price_cus.toFixed(2);
    page_load_price_cus = '$'+page_load_price_cus;
    var outOfStockPhrase  = "Min Order should be 3 meters";
  jQuery('.product-price-fabric_custom').text(page_load_price_cus);
    jQuery('#meter_box').keyup(function() {
      meter_val = this.value;
      var conv_m = meter_val * 100;
      qunt_val = meter_val * 10;
      var_price = $('.product-price-fabric_custom').attr('data-upprice');
      qttt_val = $('.js-qty__num').val();
      var_price =parseInt(var_price);
      qttt_val = parseInt(qunt_val);
      ////////////////
        if(qttt_val > 5 ){
         jQuery('.cv_min_qty').hide();
         jQuery('#AddToCart-').removeClass('disabled'); 
  
        }
      ////////////////
     if(cent_val_update){
        quan_update = cent_val_update + qunt_val
        jQuery('.js-qty__num').val(quan_update);
        mul_price = var_price * quan_update;
        mul_price = mul_price/100;
        mul_price = mul_price.toFixed(2);
        mul_price = '$'+mul_price;
        jQuery('.product-price-fabric_custom').text(mul_price);
      }
      else if(cent_val_update== 0){
        quan_update = qunt_val
        jQuery('.js-qty__num').val(quan_update);
        mul_price = var_price * quan_update;
        mul_price = mul_price/100;
        mul_price = mul_price.toFixed(2);
        mul_price = '$'+mul_price;
        jQuery('.product-price-fabric_custom').text(mul_price);
      }
      else{
        quan_update = qunt_val;
        jQuery('.js-qty__num').val(quan_update);
        mul_price = var_price * quan_update;
        mul_price = mul_price/100;
        mul_price = mul_price.toFixed(2);
        mul_price = '$'+mul_price;
        jQuery('.product-price-fabric_custom').text(mul_price);
        
      }
    });

    //  quick view cv_min_qty on load
    var plusmin_qty = $(".modal--is-active").find('#qtyval-modal').val();
    var availStock = $(".modal--is-active").find('.cv_fabric_stock').text();
    var meterboxVal = $('.modal--is-active').find('#meter_box-modal').val(); 
    meter_val = $('.modal--is-active').find(".fabric_m_c").val();
    qunt_val = meter_val * 10;
    var_price = $('.modal--is-active').find('.product-price-fabric_custom').attr('data-upprice');
    qttt_val = $('.modal--is-active').find('.js-qty__num').val();
    var_price =parseInt(var_price);
    var_price = parseInt(var_price);
      
    if(cent_val_update){
        /////////////
        setTimeout(function(){
          if(plusmin_qty >= 5 && availStock != 0 ){
            $('.modal--is-active').find('.cv_min_qty').hide();
             $('.modal--is-active').find("#AddToCart--modal").removeClass('disabled');     
          }else if(availStock == 0 && meterboxVal < 3 ){
            $('.modal--is-active').find('.cv_min_qty').text(outOfStockPhrase);
            $('.modal--is-active').find('.cv_min_qty').show();
            $('.modal--is-active').find("#AddToCart--modal").addClass('disabled');     
          }else if(availStock == 0 && meterboxVal >= 3){
            $('.modal--is-active').find('.cv_min_qty').hide();
            $('.modal--is-active').find("#AddToCart--modal").removeClass('disabled');     
          }
          else{
            
            $('.modal--is-active').find('.cv_min_qty').show();
            $('.modal--is-active').find("#AddToCart--modal").addClass('disabled');     
          }
        },300);
        ////////////
        quan_update = cent_val_update + qunt_val;
        $('.modal--is-active').find('.js-qty__num').val(quan_update);
        mul_price = var_price * quan_update;
        mul_price = mul_price/100;
        mul_price = mul_price.toFixed(2);
        mul_price = '$'+mul_price;
        $('.modal--is-active').find('.product-price-fabric_custom').text(mul_price);
    
    }
    else if(cent_val_update== 0){
           
         setTimeout(function(){
          if(plusmin_qty >= 5 && availStock != 0 ){
            $('.modal--is-active').find('.cv_min_qty').hide();
            $('.modal--is-active').find("#AddToCart--modal").removeClass('disabled');         
          }else if(availStock == 0 && meterboxVal < 3 ){
           $('.modal--is-active').find('.cv_min_qty').text(outOfStockPhrase);
           $('.modal--is-active').find('.cv_min_qty').show();
           $('.modal--is-active').find("#AddToCart--modal").addClass('disabled');         
          }else if(availStock == 0 && meterboxVal >= 3){
            $('.modal--is-active').find('.cv_min_qty').hide();
            $('.modal--is-active').find("#AddToCart--modal").removeClass('disabled');         
          }
          else{
            $('.modal--is-active').find('.cv_min_qty').show();
            $('.modal--is-active').find("#AddToCart--modal").addClass('disabled');     
          }
         },300);
          quan_update = qunt_val;
          $('.modal--is-active').find('.js-qty__num').val(quan_update);
          mul_price = var_price * quan_update;
          mul_price = mul_price/100;
          mul_price = mul_price.toFixed(2);
          mul_price = '$'+mul_price;
          $('.modal--is-active').find('.product-price-fabric_custom').text(mul_price);
    
    }
    else{
          setTimeout(function(){
          if(plusmin_qty >= 5 && availStock != 0 ){
            $('.modal--is-active').find('.cv_min_qty').hide();
            $('.modal--is-active').find("#AddToCart--modal").removeClass('disabled');     
          }else if(availStock == 0 && meterboxVal < 3 ){
            $('.modal--is-active').find('.cv_min_qty').text(outOfStockPhrase);
            $('.modal--is-active').find('.cv_min_qty').show();
            $('.modal--is-active').find("#AddToCart--modal").addClass('disabled');     
          }else if(availStock == 0 && meterboxVal >= 3){
            $('.modal--is-active').find('.cv_min_qty').hide();
            $('.modal--is-active').find("#AddToCart--modal").removeClass('disabled');     
          }
          else{
            $('.modal--is-active').find('.cv_min_qty').show();
            $('.modal--is-active').find("#AddToCart--modal").addClass('disabled'); 
          }
           },300);
          quan_update = qunt_val;
          $('.modal--is-active').find('.js-qty__num').val(quan_update);
          mul_price = var_price * quan_update;
          mul_price = mul_price/100;
          mul_price = mul_price.toFixed(2);
          mul_price = '$'+mul_price;
          $('.modal--is-active').find('.product-price-fabric_custom').text(mul_price);
          
    }
    // quick view cv_min_qty on load
  }
    console.log("worked")
    var minusmin_qty, plusmin_qty,min_qty, sec_optionval,contain_val,combo_price_sel,combo_value, fabric_comp, fabric_stock, plus_mul_price,plus_quan_update,plus_qttt_val,plus_var_price,plus_qunt_val,plus_meter_val,page_load_price,page_load_price_cus,qunt_val, meter_val, cent_val,qttt_val,qaunt_vall,v_price,quan_update,cent_val_update,quntupdate_val,combo_quant,var_price,combo_price,mul_price,var_price_fc,mul_price_woc,mul_pricess,mul_prices;
    fabric_comp = $('.cv_fabric_comp').attr('data-comp');
    fabric_comp = fabric_comp * 10;
    fabric_comp = fabric_comp/100;
    fabric_comp = fabric_comp.toFixed(2);
    fabric_comp = '$'+fabric_comp+ '/Meter';
    $('.cv_fabric_comp').text(fabric_comp);
    fabric_stock = $('.cv_fabric_stock').text();
    fabric_stock =parseInt(fabric_stock);
    fabric_stock = fabric_stock / 10;
    $('.cv_fabric_stock').text(fabric_stock)
    page_load_price = $('.product-price-fabric').attr('data-p');
    page_load_price = parseInt(page_load_price);
    page_load_price = page_load_price * 10;
    page_load_price = page_load_price/100;
    page_load_price = page_load_price.toFixed(2);
    page_load_price = '$'+page_load_price+ '/Meter';
    jQuery('.product-price-fabric').text(page_load_price);
    page_load_price_cus = $('.product-price-fabric_custom').attr('data-price');
    page_load_price_cus = parseInt(page_load_price_cus);
    page_load_price_cus = page_load_price_cus * 10;
    page_load_price_cus = page_load_price_cus/100;
    page_load_price_cus = page_load_price_cus.toFixed(2);
    page_load_price_cus = '$'+page_load_price_cus;
    var outOfStockPhrase  = "Min Order should be 3 meters";
  jQuery('.product-price-fabric_custom').text(page_load_price_cus);
    jQuery('#meter_box').keyup(function() {
      meter_val = this.value;
      var conv_m = meter_val * 100;
      qunt_val = meter_val * 10;
      var_price = $('.product-price-fabric_custom').attr('data-upprice');
      qttt_val = $('.js-qty__num').val();
      var_price =parseInt(var_price);
      qttt_val = parseInt(qunt_val);
      ////////////////
        if(qttt_val > 5 ){
         jQuery('.cv_min_qty').hide();
         jQuery('#AddToCart-').removeClass('disabled'); 
  
        }
      ////////////////
     if(cent_val_update){
        quan_update = cent_val_update + qunt_val
        jQuery('.js-qty__num').val(quan_update);
        mul_price = var_price * quan_update;
        mul_price = mul_price/100;
        mul_price = mul_price.toFixed(2);
        mul_price = '$'+mul_price;
        jQuery('.product-price-fabric_custom').text(mul_price);
      }
      else if(cent_val_update== 0){
        quan_update = qunt_val
        jQuery('.js-qty__num').val(quan_update);
        mul_price = var_price * quan_update;
        mul_price = mul_price/100;
        mul_price = mul_price.toFixed(2);
        mul_price = '$'+mul_price;
        jQuery('.product-price-fabric_custom').text(mul_price);
      }
      else{
        quan_update = qunt_val;
        jQuery('.js-qty__num').val(quan_update);
        mul_price = var_price * quan_update;
        mul_price = mul_price/100;
        mul_price = mul_price.toFixed(2);
        mul_price = '$'+mul_price;
        jQuery('.product-price-fabric_custom').text(mul_price);
        
      }
    });
  
  
  jQuery('#centimeter').on('change', function() {
       setTimeout(function(){
 min_qty = $('#qtyval').val();
       },300)
    cent_val = this.value;
    cent_val = cent_val/10;
    cent_val = parseInt(cent_val);
    qunt_val= parseInt(qunt_val);
     qttt_val = $('.js-qty__num').val();
    
    var availStock = jQuery('.cv_fabric_stock').text();
  var meterboxVal = jQuery('#meter_box').val(); 
       
    combo_quant= cent_val + qunt_val;
   if(meter_val){
         /////////////
     setTimeout(function(){
       
        if(min_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');   
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');   
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');  
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
      
     },300);
 ////////////
      jQuery('.js-qty__num').val(combo_quant);
       var_price_fc = $('.product-price-fabric_custom').attr('data-upprice');
      quntupdate_val = $('.js-qty__num').val();
      v_price = var_price_fc * quntupdate_val
      v_price = v_price/100;
      v_price = v_price.toFixed(2);
      v_price = '$'+v_price;
      jQuery('.product-price-fabric_custom').text(v_price);

    }
    else{
          /////////////
     setTimeout(function(){
            if(min_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');      
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');      
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');      
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
      
     },300);
 ////////////
      cent_val = cent_val + 10;
      jQuery('.js-qty__num').val(cent_val);
      var_price_fc = $('.product-price-fabric_custom').attr('data-upprice');
      quntupdate_val = $('.js-qty__num').val();
      quntupdate_val = parseInt(quntupdate_val);
      v_price = var_price_fc * quntupdate_val
      v_price = v_price/100;
      v_price = v_price.toFixed(2);
      v_price = '$'+v_price;
      jQuery('.product-price-fabric_custom').text(v_price);
    }
cent_val_update = cent_val;
  
  });

  // quick view start

  jQuery(document).on('change','#centimeter-modal', function() {
    var _this = $(this);
       setTimeout(function(){
     min_qty = _this.parents(".fullofdiv").find('#qtyval-modal').val();
       },300)
    cent_val = this.value;
    cent_val = cent_val/10;
    cent_val = parseInt(cent_val);
    qunt_val= parseInt(qunt_val);
     qttt_val = _this.parents(".fullofdiv").find('.js-qty__num').val();
    
    var availStock = _this.parents(".fullofdiv").find('.cv_fabric_stock').text();
  var meterboxVal = _this.parents(".fullofdiv").find('#meter_box-modal').val(); 
       
    combo_quant= cent_val + qunt_val;
   if(meter_val){
         /////////////
     setTimeout(function(){
       
        if(min_qty >= 5 && availStock != 0 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents("form").find("#AddToCart--modal").removeClass('disabled');  
      }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents("form").find("#AddToCart--modal").addClass('disabled');  
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents("form").find("#AddToCart--modal").removeClass('disabled');  
      }
      else{
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents("form").find("#AddToCart--modal").addClass('disabled');
      }
      
     },300);
 ////////////
      _this.parents(".fullofdiv").find('.js-qty__num').val(combo_quant);
       var_price_fc = _this.parents(".fullofdiv").find('.product-price-fabric_custom').attr('data-upprice');
      quntupdate_val = _this.parents(".fullofdiv").find('.js-qty__num').val();
      v_price = var_price_fc * quntupdate_val
      v_price = v_price/100;
      v_price = v_price.toFixed(2);
      v_price = '$'+v_price;
      _this.parents(".fullofdiv").find('.product-price-fabric_custom').text(v_price);

    }
    else{
          /////////////
     setTimeout(function(){
            if(min_qty >= 5 && availStock != 0 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents("form").find("#AddToCart--modal").removeClass('disabled');      
      }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
         _this.parents("form").find("#AddToCart--modal").addClass('disabled');           
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents("form").find("#AddToCart--modal").removeClass('disabled');           
      }
      else{
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
         _this.parents("form").find("#AddToCart--modal").addClass('disabled');     
      }
      
     },300);
 ////////////
      cent_val = cent_val + 10;
      _this.parents(".fullofdiv").find('.js-qty__num').val(cent_val);
      var_price_fc = _this.parents(".fullofdiv").find('.product-price-fabric_custom').attr('data-upprice');
      quntupdate_val = _this.parents(".fullofdiv").find('.js-qty__num').val();
      quntupdate_val = parseInt(quntupdate_val);
      v_price = var_price_fc * quntupdate_val
      v_price = v_price/100;
      v_price = v_price.toFixed(2);
      v_price = '$'+v_price;
      _this.parents(".fullofdiv").find('.product-price-fabric_custom').text(v_price);
    }
cent_val_update = cent_val;
  
  });

$(document).on("click",'.modal--quick-shop .qtyplus',function(e){
  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  var _this = $(this);
  var currentVal = $(this).parent('.cv--meter_qty').find(".fabric_m_c").val();
  currentVal = parseInt(currentVal);

  if (!isNaN(currentVal)) {
    // Increment
    $(this).parents('.cv--meter_qty').find(".fabric_m_c").val(currentVal + 1);
  } else {
    // Otherwise put a 0 there
    $(this).parents('.cv--meter_qty').find(".fabric_m_c").val(0);
  }
  /////////////////////////////////////////////////////////
  meter_val = $(this).parents('.cv--meter_qty').find(".fabric_m_c").val();
  qunt_val = meter_val * 10;
  var_price = $(this).parents(".fullofdiv").find('.product-price-fabric_custom').attr('data-upprice');
  qttt_val = $(this).parents(".fullofdiv").find('.js-qty__num').val();
  var_price =parseInt(var_price);
    var_price = parseInt(var_price);
  
  var availStock = $(this).parents(".fullofdiv").find('.cv_fabric_stock').text();
  var meterboxVal = $(this).parents(".fullofdiv").find('#meter_box-modal').val(); 
  
  setTimeout(function(){
 plusmin_qty = _this.parents(".fullofdiv").find('#qtyval-modal').val();
  },300)
  if(cent_val_update){
    /////////////
    setTimeout(function(){
      if(plusmin_qty >= 5 && availStock != 0 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
         _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled');     
      }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
         _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled');     
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
         _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled');     
      }
      else{
        
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
         _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled');     
      }
    },300);
    ////////////
    quan_update = cent_val_update + qunt_val;
    _this.parents(".fullofdiv").find('.js-qty__num').val(quan_update);
     mul_price = var_price * quan_update;
     mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      _this.parents(".fullofdiv").find('.product-price-fabric_custom').text(mul_price);

  }
    else if(cent_val_update== 0){
       
     setTimeout(function(){
          if(plusmin_qty >= 5 && availStock != 0 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled');         
      }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled');         
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled');         
      }
      else{
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled');     
      }
     },300);
      quan_update = qunt_val;
      _this.parents(".fullofdiv").find('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      _this.parents(".fullofdiv").find('.product-price-fabric_custom').text(mul_price);

    }
     else{
      setTimeout(function(){
          if(plusmin_qty >= 5 && availStock != 0 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled');     
      }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled');     
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled');     
      }
      else{
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled'); 
      }
       },300);
      quan_update = qunt_val;
      _this.parents(".fullofdiv").find('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      _this.parents(".fullofdiv").find('.product-price-fabric_custom').text(mul_price);
      
    }
}); 

$(document).on("click",'.modal--quick-shop .qtyminus',function(e){
  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  var _this = $(this);
  var currentVal = $(this).parents('.cv--meter_qty').find(".fabric_m_c").val();
  currentVal = parseInt(currentVal);

  if (!isNaN(currentVal) && currentVal > 0) {
    // Increment
    $(this).parents('.cv--meter_qty').find(".fabric_m_c").val(currentVal - 1);
  } else {
    // Otherwise put a 0 there
    $(this).parents('.cv--meter_qty').find(".fabric_m_c").val(0);
  }
  ///////////////////////////////
   meter_val = $(this).parents('.cv--meter_qty').find(".fabric_m_c").val();
  qunt_val = meter_val * 10;
  var_price = _this.parents(".fullofdiv").find('.product-price-fabric_custom').attr('data-upprice');
  qttt_val = _this.parents(".fullofdiv").find('.js-qty__num').val();
  var_price =parseInt(var_price);
    var_price = parseInt(var_price);
  
  var availStock = _this.parents(".fullofdiv").find('.cv_fabric_stock').text();
  var meterboxVal = _this.parents(".fullofdiv").find('#meter_box-modal').val(); 
  
 setTimeout(function(){
 minusmin_qty = _this.parents(".fullofdiv").find('#qtyval-modal').val();
  },300)
  if(cent_val_update){
        /////////////
    setTimeout(function(){
       if(minusmin_qty >= 5 && availStock != 0 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled');  
      }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled');  
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled');  
      }
      else{
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled'); 
      }
     
    },300);
    ////////////
    quan_update = cent_val_update + qunt_val;
    _this.parents(".fullofdiv").find('.js-qty__num').val(quan_update);
     mul_price = var_price * quan_update;
     mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      _this.parents(".fullofdiv").find('.product-price-fabric_custom').text(mul_price);

  }
    else if(cent_val_update== 0){
          /////////////
    setTimeout(function(){
      if(minusmin_qty >= 5 && availStock != 0 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled'); 
      }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled'); 
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled'); 
      }
      else{
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled'); 
      }
    },300);
    ////////////
      quan_update = qunt_val;
      _this.parents(".fullofdiv").find('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      _this.parents(".fullofdiv").find('.product-price-fabric_custom').text(mul_price);

    }
     else{
           /////////////
    setTimeout(function(){
      if(minusmin_qty >= 5 && availStock != 0 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled'); 
      }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled'); 
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled'); 
      }
      else{
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled'); 
      }
    },300);
    ////////////
      quan_update = qunt_val;
      _this.parents(".fullofdiv").find('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      _this.parents(".fullofdiv").find('.product-price-fabric_custom').text(mul_price);
      
    }
  
    ////////////////////////
  if(qttt_val > 5 && availStock != 0){
    _this.parents(".fullofdiv").find('.cv_min_qty').hide();
    _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled'); 

  }else if(availStock == 0 && meterboxVal < 3 ){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').text(outOfStockPhrase);
        _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
        _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled'); 
      }else if(availStock == 0 && meterboxVal >= 3){
        _this.parents(".fullofdiv").siblings('.cv_min_qty').hide();
        _this.parents(".modal--is-active").find("#AddToCart--modal").removeClass('disabled'); 
      }
   else{
    _this.parents(".fullofdiv").siblings('.cv_min_qty').show();
    _this.parents(".modal--is-active").find("#AddToCart--modal").addClass('disabled');  
  }
  /////////////////
  
  
});


jQuery(document).on("click",".modal--quick-shop .cv--add-to-cart",function(e){
    e.preventDefault();

    var pattern = $('.cv--digi-product').val();
    var qttt_val1 = jQuery(this).parents(".modal--quick-shop").find('#qtyval-modal').val();
   if (qttt_val1 >= 5 ){
//     setTimeout(function(){
      if(pattern == ''){
    
       jQuery.ajax({
          type: "POST",
          url: lang+'/cart/add.js',
          data: jQuery(this).parents(".modal--quick-shop").find('form[action="'+lang+'/cart/add"]').serialize(),
          async: false,
          success: function(){
              window.top.location.href = lang+"/cart";
          }
        })
      }else{
        jQuery.ajax({
          type: "POST",
          url: lang+'/cart/add.js',
          data: {
            quantity: 1,
            id: pattern,
         
          },
           
          async: false
        })

        jQuery.ajax({
          type: "POST",
          url: lang+'/cart/add.js',
          data: jQuery(this).parents(".modal--quick-shop").find('form[action="'+lang+'/cart/add"]').serialize(),
   
          async: false,
          success: function(){
            window.top.location.href = lang+"/cart";

          }
        })
      }
//     },500);
   }
  });  


jQuery(document).on("click",'.modal--quick-shop .cv--sample-btn',function(){
    var sample = $(this).siblings('input').val();
    jQuery.ajax({
      type: "POST",
      url: lang+'/cart/add.js',
      data: {
        quantity: 1,
        id: sample
      },
      async: false,
       success: function(){
            window.top.location.href = lang+"/cart";

          }
    })
});  

  jQuery(document).on("mouseenter",".modal--is-active .cv_pre_ques",function() {
    jQuery('.modal--is-active .preorder_hover_content').show();
  });
  jQuery(document).on("mouseleave",".modal--is-active .cv_pre_ques",function() {
    jQuery('.modal--is-active .preorder_hover_content').hide();
  });
  jQuery(document).on("click",".modal--is-active .cv_pre_ques",function() {
    jQuery('.modal--is-active .preorder_hover_content').toggle();
  });

  jQuery(document).on("mouseover",".questionmark",function() {
    jQuery('.modal--is-active .hoverblock1').show();
  });
  jQuery(document).on("mouseleave",".questionmark",function() {
    jQuery('.modal--is-active .hoverblock1').hide();
  });

  jQuery(document).on("mouseover",".price_quest",function() {
    jQuery('.modal--is-active .price_text_hover').show();
  });
  jQuery(document).on("mouseleave",".price_quest",function() {
    jQuery('.modal--is-active .price_text_hover').hide();
  });


  

  // quick view end

    //   facric template js for meter and centimeter code end here
  
      // This button will increment the value
   
    // This button will decrement the value till 0
    // This button will decrement the value till 0
$('.qtyplus').on("click",function(e){
  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  var currentVal = $(this).parent('.cv--meter_qty').find(".fabric_m_c").val();
  currentVal = parseInt(currentVal);

  if (!isNaN(currentVal)) {
    // Increment
    $(this).parents('.cv--meter_qty').find(".fabric_m_c").val(currentVal + 1);
  } else {
    // Otherwise put a 0 there
    $(this).parents('.cv--meter_qty').find(".fabric_m_c").val(0);
  }
  /////////////////////////////////////////////////////////
  meter_val = $(this).parents('.cv--meter_qty').find(".fabric_m_c").val();
  qunt_val = meter_val * 10;
  var_price = $('.product-price-fabric_custom').attr('data-upprice');
  qttt_val = $('.js-qty__num').val();
  var_price =parseInt(var_price);
    var_price = parseInt(var_price);
  
  var availStock = jQuery('.cv_fabric_stock').text();
  var meterboxVal = jQuery('#meter_box').val(); 
  
  setTimeout(function(){
 plusmin_qty = $('#qtyval').val();
  },300)
  if(cent_val_update){
    /////////////
    setTimeout(function(){
      if(plusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
    },300);
    ////////////
    quan_update = cent_val_update + qunt_val;
    jQuery('.js-qty__num').val(quan_update);
     mul_price = var_price * quan_update;
     mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);

  }
    else if(cent_val_update== 0){
       
     setTimeout(function(){
          if(plusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');    
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');    
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');    
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
     },300);
      quan_update = qunt_val;
      jQuery('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);

    }
     else{
      setTimeout(function(){
          if(plusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');    
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');    
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');    
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
       },300);
      quan_update = qunt_val;
      jQuery('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);
      
    }
  

  
  
});

// cv_min_qty on load

plusmin_qty = $('#qtyval').val();
var availStock = jQuery('.cv_fabric_stock').text();
var meterboxVal = jQuery('#meter_box').val();  
meter_val = $(".fabric_m_c").val();
qunt_val = meter_val * 10; 
var_price = $('.product-price-fabric_custom').attr('data-upprice');
qttt_val = $('.js-qty__num').val();
var_price =parseInt(var_price);
var_price = parseInt(var_price);  
  
if(cent_val_update){
    /////////////
    setTimeout(function(){
      if(plusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
    },300);
    ////////////
    quan_update = cent_val_update + qunt_val;
    jQuery('.js-qty__num').val(quan_update);
     mul_price = var_price * quan_update;
     mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);
}
else if(cent_val_update== 0){
       
     setTimeout(function(){
      if(plusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');    
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');    
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');    
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
     },300);
      quan_update = qunt_val;
      jQuery('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);

}
else{
      setTimeout(function(){
      if(plusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');    
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');    
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');    
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
       },300);
      quan_update = qunt_val;
      jQuery('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);
      
}

// cv_min_qty on load 



  
$('.qtyminus').on("click",function(e){
  // Stop acting like a button
  e.preventDefault();
  // Get the field name
  var currentVal = $(this).parents('.cv--meter_qty').find(".fabric_m_c").val();
  currentVal = parseInt(currentVal);

  if (!isNaN(currentVal) && currentVal > 0) {
    // Increment
    $(this).parents('.cv--meter_qty').find(".fabric_m_c").val(currentVal - 1);
  } else {
    // Otherwise put a 0 there
    $(this).parents('.cv--meter_qty').find(".fabric_m_c").val(0);
  }
  ///////////////////////////////
   meter_val = $(this).parents('.cv--meter_qty').find(".fabric_m_c").val();
  qunt_val = meter_val * 10;
  var_price = $('.product-price-fabric_custom').attr('data-upprice');
  qttt_val = $('.js-qty__num').val();
  var_price =parseInt(var_price);
    var_price = parseInt(var_price);
  
  var availStock = jQuery('.cv_fabric_stock').text();
  var meterboxVal = jQuery('#meter_box').val(); 
  
 setTimeout(function(){
 minusmin_qty = $('#qtyval').val();
  },300)
  if(cent_val_update){
        /////////////
    setTimeout(function(){
       if(minusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled'); 
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled'); 
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled'); 
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
     
    },300);
    ////////////
    quan_update = cent_val_update + qunt_val;
    jQuery('.js-qty__num').val(quan_update);
     mul_price = var_price * quan_update;
     mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);

  }
    else if(cent_val_update== 0){
          /////////////
    setTimeout(function(){
      if(minusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
    },300);
    ////////////
      quan_update = qunt_val;
      jQuery('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);

    }
     else{
           /////////////
    setTimeout(function(){
      if(minusmin_qty >= 5 && availStock != 0 ){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }
      else{
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }
    },300);
    ////////////
      quan_update = qunt_val;
      jQuery('.js-qty__num').val(quan_update);
      mul_price = var_price * quan_update;
      mul_price = mul_price/100;
      mul_price = mul_price.toFixed(2);
      mul_price = '$'+mul_price;
      jQuery('.product-price-fabric_custom').text(mul_price);
      
    }
  
    ////////////////////////
  if(qttt_val > 5 && availStock != 0){
    jQuery('.cv_min_qty').hide();
    jQuery('#AddToCart-').removeClass('disabled');

  }else if(availStock == 0 && meterboxVal < 3 ){
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        jQuery('#AddToCart-').addClass('disabled');
      }else if(availStock == 0 && meterboxVal >= 3){
        jQuery('.cv_min_qty').hide();
        jQuery('#AddToCart-').removeClass('disabled');
      }
   else{
    jQuery('.cv_min_qty').show();
    jQuery('#AddToCart-').addClass('disabled'); 
  }
  /////////////////
  
  
});
  //////////////////////////
    $('.cv--add-to-cart').click(function(e){
      qttt_val = jQuery('#qtyval').val();
     var availStock = jQuery('.cv_fabric_stock').text();
     var meterboxVal = jQuery('#meter_box').val(); 
      
   
      if(qttt_val < 5 && availStock !=0 ){
        e.preventDefault();
        e.stopPropagation();
//         $(this).addClass('disable');
        jQuery('.cv_min_qty').show();

      }else if(availStock==0 && meterboxVal < 3){
         e.preventDefault();
        jQuery('.cv_min_qty').text(outOfStockPhrase);
        jQuery('.cv_min_qty').show();
        
      }
      else{

      }
    });
  
  
  /////////////////////////
  $('#qtyval').val(10);
  
  
});
///////////////////////////////double option code start here 1 April 2019//////////////////////
  jQuery('.cv_sec_var').change(function(){
    var first_val = $(this).val();

    var combo_price,combo_val,update_price,qty_value,total_price,combo_policy,combo_inv;
    update_price = $('.product-price-fabric_custom').attr('data-upprice');
    qty_value = $('#qtyval').val();
    total_price = update_price * qty_value;
    jQuery('.product-single__variants  option').each(function(){
      jQuery(this).trigger('change');
      combo_val = jQuery(this).attr('data-title');
      combo_price = jQuery(this).attr('data-vprice');
      combo_policy = jQuery(this).attr('data-policy');
      combo_inv = jQuery(this).attr('data-inv');
      var contain  = combo_val.indexOf(first_val);
      if( contain > -1){
        combo_price = combo_price * 10;
        combo_price = combo_price/100;
        combo_price = combo_price.toFixed(2);
        combo_price = '$'+combo_price;;
        jQuery('.product-price-fabric_custom').text(combo_price);
        /////////
        if(combo_policy == 'continue' && combo_inv <= 0){
          $('.add-to-cart').text('Pre-order');
          $('.cv_out_stock').show();
          $('.cv_onchnage_preorder').show();
          $('.cv_out_stock').attr('data-selected',first_val);
          $('.add-to-cart').text('Pre-order');
        }
        else if(combo_inv <= 0){
          $('.cv_preorder_text').hide();
          $('.cv_out_stock').show();
          $('.cv_out_stock').attr('data-selected',first_val);
          $('.add-to-cart').text('out of stock');
        }
        else if(combo_inv >= 1){
          $('.cv_preorder_text').hide();
          $('.cv_out_stock').hide();
                    
          $('.add-to-cart').text('Add to cart');

        }
        /////////
       
      }
      else{
      }
    });
  });
  
  
  
////////////////////////// double option code end here 1april 2019 ///////////////////////  
  
 jQuery('.cv--add-to-cart').click(function(e){
    e.preventDefault();

    var pattern = $('.cv--digi-product').val();
    var qttt_val1 = jQuery('#qtyval').val();
   if (qttt_val1 >= 5 ){
//     setTimeout(function(){
      if(pattern == ''){
    
       jQuery.ajax({
          type: "POST",
          url: lang+'/cart/add.js',
          data: $('form[action="'+lang+'/cart/add"]').serialize(),
          async: false,
          success: function(){
              window.top.location.href = lang+"/cart";
          }
        })
      }else{
        jQuery.ajax({
          type: "POST",
          url: lang+'/cart/add.js',
          data: {
            quantity: 1,
            id: pattern,
         
          },
           
          async: false
        })

        jQuery.ajax({
          type: "POST",
          url: lang+'/cart/add.js',
          data: $('form[action="'+lang+'/cart/add"]').serialize(),
   
          async: false,
          success: function(){
            window.top.location.href = lang+"/cart";

          }
        })
      }
//     },500);
   }
  });
  
  jQuery('.cv--sample-btn').click(function(){
    var sample = $('.cv--sample-product-wrap input').val();
    jQuery.ajax({
      type: "POST",
      url: lang+'/cart/add.js',
      data: {
        quantity: 1,
        id: sample
      },
      async: false,
       success: function(){
            window.top.location.href = lang+"/cart";

          }
    })
  });
  

  jQuery( ".questionmark" ).mouseover(function() {
    jQuery('.hoverblock1').show();
  });
  jQuery( ".questionmark" ).mouseleave(function() {
    jQuery('.hoverblock1').hide();
  });

//   jQuery( ".questionmark" ).click(function() {
//     jQuery('.hoverblock1').toggle();
//   });
  
  jQuery( ".price_quest" ).mouseover(function() {
    jQuery('.price_text_hover').show();
  });
  jQuery( ".price_quest" ).mouseleave(function() {
    jQuery('.price_text_hover').hide();
  });
//   jQuery( ".price_quest" ).click(function() {
//     jQuery('.price_text_hover').toggle();
//   });
  jQuery( ".pattern_ques" ).click(function() {
    jQuery('.pattern_text_hover').toggle();
  });
    jQuery( ".pattern_ques" ).mouseover(function() {
    jQuery('.pattern_text_hover').show();
  });
  jQuery( ".pattern_ques" ).mouseleave(function() {
    jQuery('.pattern_text_hover').hide();
  });
     jQuery( ".cv_pre_ques" ).mouseover(function() {
    jQuery('.preorder_hover_content').show();
  });
  jQuery( ".cv_pre_ques" ).mouseleave(function() {
    jQuery('.preorder_hover_content').hide();
  });
  jQuery( ".cv_pre_ques" ).click(function() {
    jQuery('.preorder_hover_content').toggle();
  });


jQuery('.cv_sel_out').click(function(){
var cv_sel = jQuery(this).attr('data-selected');
jQuery('.cv_var_titl').text(cv_sel);
});
jQuery('.cv_sel_out').click(function(){
jQuery('body.fabric').addClass('cv_soldout_open');
});
jQuery('.fancybox-close-small').click(function(){

jQuery('body.fabric').removeClass('cv_soldout_open');
});


jQuery(document).ready(function(){
// jQuery("#ucfrom").keyup(function(){
//   $("#ucresult").html();
//    var newVideoName = jQuery("#ucfrom").val();
//   var meterval =  newVideoName * 0.914;
//   jQuery("#ucmeter").val(meterval);
//    $("#ucresult").html(newVideoName + " Yard = " + meterval + " Meter");
// //alert(newVideoName);
  
// });
//   jQuery("#ucmeter").keyup(function(){
    
//     $("#ucresult").html();
//     var newVideoName1 = jQuery("#ucmeter").val();
//     var meterval1 =  newVideoName1 * 1.093;
//     jQuery("#ucfrom").val(meterval1);
//     //$("#ucfrom").text(newVideoName);
//     //alert(newVideoName);
//    $("#ucresult").html(newVideoName1 + " Meter = " + meterval1 + " Yard");
//   });
  
  if(jQuery("#ucfrom").val() == "" ){
    $(".ucresulttext").css("display:none");
  }
   if(jQuery("#ucmeter").val() == "" ){
    $(".ucresulttext").css("display:none");
  }
  
  
  
  
  $('#Convert').click(function(){
var newVideoName = jQuery("#ucfrom").val();
    var meterval =  newVideoName * 0.914;
  jQuery("#ucmeter").val(meterval);
   $("#ucresult").html(newVideoName + " Yard = " + meterval + " Meter");

  });
  
////////////////////////////////////////////////////////
//   meter to yard conversion code start here
//   jQuery("#ucfrommeter").keyup(function(){
//   $("#ucresult").html();
//    var mater_vales = jQuery(this).val();

//   var centimeteer_values =  mater_vales * 100;
//     console.log(centimeteer_values)
//   jQuery("#uccent").val(centimeteer_values);
//    $("#meter_centresult").html(mater_vales + " Meter = " + centimeteer_values + " Centimeter");
// //alert(newVideoName);
  
// });
  
//   jQuery("#uccent").keyup(function(){
    
//     $("#meter_centresult").html();
//     var newVideoName11 = jQuery("#uccent").val();
//     var meterval11 =  newVideoName11 / 100;
//     jQuery("#ucfrommeter").val(meterval11);
//     //$("#ucfrom").text(newVideoName);
//     //alert(newVideoName);
//    $("#meter_centresult").html(newVideoName11 + " Meter = " + meterval11 + " Centimeter");
//   });

  jQuery('.Convert_meter_ce').click(function(){
    var m_val =jQuery('#ucfrommeter').val();
    var c_val = jQuery('#uccent').val();
    var centimeteer_values1 =  m_val * 1.09361;
    jQuery("#uccent").val(centimeteer_values1);
    $("#meter_centresult").html(m_val + " Meter = " + centimeteer_values1 + " Yard");
//     var meterval11 =  c_val / 100;
//     $("#ucfrommeter").text(meterval11);
//     $("#meter_centresult").html(c_val + " Meter = " + meterval11 + " Centimeter");
  });
  
//   meter to yard conversion code end here
//   meter-yard and yard-meter hide -show code start here
//   $('.covert_meter_cent').click(function(){
// console.log('click');
// $('#meter_centimeter').show();
// $('#undctable').hide();
// $(this).hide();
// $('.covert_yard_meter').show();
// });
//   $('.covert_yard_meter').click(function(){
// $('#undctable').show();
// $('#meter_centimeter').hide();
// $(this).hide();
// $('.covert_meter_cent').show();
// });
  
  $('.cv_covertor').click(function(){
    $(this).parents('#undctable').hide();
    $('#meter_centimeter').show();
  });
  $('.cv_conv_my').click(function(){
    $(this).parents('#meter_centimeter').hide();
    $('#undctable').show();
  });
  
  //   meter-yard and yard-meter hide -show code end here
});
 jQuery(document).ready(function(){
    var inp_val1 = $("#qty_prd").val();
     if(inp_val1 == "1"){
      jQuery(".product-single__form .js-qty__wrapper").find('input').val("10").trigger("change"); 

     }
   jQuery("#qty_prd").keyup(function(){
     var inp_val =  jQuery(this).val()*10;
     
     jQuery(".product-single__form .js-qty__wrapper").find('input').val(inp_val).trigger("change");  
      var slct_val = jQuery(".slct_box").val()/10;
       var plus_a = slct_val + inp_val;
      jQuery(".product-single__form .js-qty__wrapper").find('input').val(plus_a).trigger("change");
     
     var current_price = parseInt($('.product-single__meta .product__price').attr('content'));      
     // var newTotalPrice = plus_a*current_price*10;      
     var actualprice = theme.Currency.formatMoney(newTotalPrice, theme.settings.moneyFormat);
     $('.product-single__meta .product__price').html(actualprice +  "/Meter");
      
});  
    jQuery(".slct_box").change(function(){
     var slct_val = jQuery(this).val()/10;
      
     jQuery(".product-single__form .js-qty__wrapper").find('input').val(slct_val).trigger("change");
        var inp_val = $("#qty_prd").val()*10;
      var plus_a = slct_val + inp_val;
       jQuery(".product-single__form .js-qty__wrapper").find('input').val(plus_a).trigger("change");
       
      var current_price = parseInt($('.product-single__meta .product__price').attr('content'));      
      //var newTotalPrice = plus_a*current_price*10;      
     var actualprice = theme.Currency.formatMoney(newTotalPrice, theme.settings.moneyFormat);
      
      $('.product-single__meta .product__price').html(actualprice +  "/Meter");
  
                        
    });  
  
      
});
//  jQuery(document).ready(function(){
//     setTimeout(function(){
//       jQuery( ".collapsibles-wrapper_98765432" ).before( jQuery( ".hulkapps-volumes" ));
//        jQuery('.hulkapps-volumes').css("display","block");
//       jQuery( ".hulkapps-volume-discount-tiers" ).after("<div class='small-heading'>please note: the offer is applied also when you combine diffrent fabrics, discounts calculated at checkout</div>");
     
                       
   
   
//      var pr_price =  parseFloat($('.product-single__meta .product-single__form').find('#prdprc').val());
//      // alert(pr_price);
//      $(".hulkapps-volume-discount-tiers tbody tr").each(function(){
//    var innerhtml = $(this).find(".hulkapps-price").html(); 
//        var zero_split = innerhtml.split("%")
      
//         var multiplay_num = parseFloat(zero_split[0])*pr_price;
//         var divide_num = multiplay_num/100;
//        divide_num = pr_price -divide_num;
//         console.log(divide_num);
//        jQuery(this).find(".dp_row").html("for <b> $"+ divide_num +"</b> per meter");
//        });
//        }, 7000); 
// });
  
// jQuery(document).ready(function(){
  
//   setTimeout(function(){
//   jQuery( ".hulkapps_option_set" ).parent().parent().parent().css('display','none');
//     }, 2000); 
//     setTimeout(function(){
//       jQuery( ".questionmark" ).before( jQuery( ".hulkapps_option_set" ).parent());
//       jQuery( ".hulkapps_option_set" ).parent().parent().parent().css('display','block');
//       jQuery( ".hulkapps_option_set" ).parent().css({
//         'background-color': '#fff',
//         'border':'1px solid #fff ',
//         'padding':'0px '
//       });
//       }, 7000); 
  
// });
  
  
  
  jQuery(document).ready(function () {
    jQuery(".questionmark").hover(
      function () {
        jQuery('.hoverblock').toggle();
      }
    );
    jQuery(".questionmark1").hover(
      function () {
        jQuery('.hoverblock1').toggle();
      }
    );
  });  
  
  
//     $(document).on('click', '[data-fancybox]', function(e) {
//       e.preventDefault();
//       var items = window[ $(this).attr('data-fancybox') ];
//       var index = $(this).attr('data-fancybox-index');
//       $.fancybox.open(items, {}, index);
  
//     });

   
//     $('[data-fancybox="images"]').fancybox({
// 	  loop: true,
 

      
      
//       afterShow : function(instance, current) {
         
//            // var pixelRatio = window.devicePixelRatio || 1;

// //             if ( pixelRatio > 1.5 ) {
// //                 current.width  = current.width  / pixelRatio;
// //                 current.height = current.height / pixelRatio;
// //             }
          
//        setTimeout(function() { 
         
//          //var itemId = current.opts.$orig.data('alt'); 
//      //    alert(itemId);
         
//        //$(".fancybox-content").find('.fancybox-video').removeAttribute("controls");
//       // $(".fancybox-content").find('.fancybox-video').removeAttr("controls");
//          $(".fancybox-content").find('.fancybox-video').attr('muted');
//        $(".fancybox-video").before("<img class='muteicon1 firsticon1 iconcss' src='//cdn.shopify.com/s/files/1/0088/3333/5356/t/44/assets/Muteicon.png?v=142487419170765461661668757004'>");
//          $(".fancybox-video").before("<img class='muteicon2 secondicon1 iconcss' style='display:none' src='//cdn.shopify.com/s/files/1/0088/3333/5356/t/44/assets/9520439e.png?v=113122528038797597671668757004'>");
         
// //        $(".fancybox-image").parent().css({
// //         'transform': 'translate(407px, 0px) scale(1, 1)', 
// // //          'transform': 'scale(1, 1)',
// //         'width': '600px',
// //          'height': '600px',
// //          'left':'0',
// //          'right': '0',
// //          'margin': '0 auto'
// //        });
         
//          $(".fancybox-bg").css({
//            'background-color': '#ffffff',
//             'opacity': '1'
         
//          });
//          /*
//          $(".fancybox-video").parent().css({
//         'transform': 'translate(0px, 0px) scale(1, 1)', 
//         'width': 'auto',
//          'height': 'auto'
//        });
//          */
         
//      // $('.fancybox-content').height('100%');    
//         // $('.fancybox-content').trigger('click');
         
//       }, 100);  
          
//        }
//     });



//   });


$(".brewwwer").each(function(){
  var text = $(this).html();
  if(text == '')
  {
    $(this).parents(".collection-sidebar__group").hide();
  }
});

$(document).ready(function(){
  window.dispatchEvent(new Event('resize'));
});
